import { type PropsWithChildren, useEffect, useState } from 'react';

import { type IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { Box, CircularProgress } from '@mui/material';

import { msalConfig } from '../../config/authConfig';

const msalInstance: IPublicClientApplication = new PublicClientApplication(msalConfig);

const MsalContextProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize MSAL instance and handle redirect promise
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();

        // Handle redirect promise to process authentication callback
        // This is critical for processing the redirect from Azure AD
        await msalInstance.handleRedirectPromise();

        setIsInitialized(true);
      } catch (error) {
        console.error('MSAL initialization error:', error);
        setIsInitialized(true); // Still render to allow error handling
      }
    };

    void initializeMsal();
  }, []);

  // Show loading indicator while MSAL is initializing and processing redirect
  if (!isInitialized) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export default MsalContextProvider;
